import http from "@/shared/services/http";

export const searchBillLading = (ladingCode: string) => http.get(`v1/bill-ladings/search/${ladingCode}`)
